import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { Text } from '@/shared/uikit/Text';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { ReplaceResidenceModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../containers/ModalContainerV1';
import { InterwillStyledForm } from '../CreateEntityModal/styled';

export const ReplaceResidenceModal: FC<ReplaceResidenceModalProps> = ({
  beneficiaryData,
  updateBeneficiaryData,
}) => {
  const { t } = useTranslation('widgets/modals', {
    keyPrefix: 'replaceResidence',
  });

  const modals = useModalsStore();

  return (
    <ModalContainerV1 title={t('title')}>
      <InterwillStyledForm>
        <InnerForm>
          <Text>{t('noDocuments')}</Text>
        </InnerForm>
        <Buttons
          style={{
            gap: 16,
          }}
        >
          <ButtonIw type="default" onClick={modals.closeModal}>
            {t('cancel')}
          </ButtonIw>
          <ButtonIw
            onClick={() => {
              modals.closeModal();
              modals.openModal({
                type: 'ResidenceModal',
                addNew: true,
                beneficiaryData,
                updateBeneficiaryData,
              });
            }}
          >
            {t('yes')}
          </ButtonIw>
        </Buttons>
      </InterwillStyledForm>
    </ModalContainerV1>
  );
};

const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
`;
